import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useUsers } from '../../../web-client/hooks/useUser';
import { useMentionResource } from '../../UIKit1/userPicker/providers/useMentionResource';
import { UserPicker } from './UserPicker';
// Format the values(UserData) returned from useUsers hook, to pass to defaultValue prop
var hydrateDefaultValue = function hydrateDefaultValue(users) {
  var isMulti = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var defaultValues = [];
  for (var userId in users) {
    var _users$userId = users[userId],
      name = _users$userId.name,
      picture = _users$userId.picture;
    // Only grabbing the values where user name exist
    if (name) {
      defaultValues.push({
        name: name,
        avatarUrl: picture,
        id: userId,
        type: 'user'
      });
    }
  }
  return isMulti ? defaultValues : defaultValues[0];
};
var UserPickerFn = function UserPickerFn(_ref) {
  var client = _ref.client,
    mentionProvider = _ref.mentionProvider,
    accountId = _ref.accountId,
    cloudId = _ref.cloudId,
    productAttributes = _ref.productAttributes,
    productKey = _ref.productKey,
    baseUrl = _ref.baseUrl,
    props = _ref.props;
  var _ref2 = props,
    name = _ref2.name,
    label = _ref2.label,
    placeholder = _ref2.placeholder,
    description = _ref2.description,
    _ref2$defaultValue = _ref2.defaultValue,
    defaultUserValue = _ref2$defaultValue === void 0 ? '' : _ref2$defaultValue,
    isRequired = _ref2.isRequired,
    isMulti = _ref2.isMulti,
    includeUsers = _ref2.includeUsers,
    includeGroups = _ref2.includeGroups,
    onChange = _ref2.onChange;
  var query = useMentionResource(mentionProvider);
  var accountIds = Array.isArray(defaultUserValue) ? defaultUserValue : [defaultUserValue];
  var usersData = useUsers(accountIds, client);

  // Hydrate the default value ourselves, since we are controlling value from <Field>
  // component value. It will get passed into the user picker as simply `value`.
  var hydratedDefaultValue = hydrateDefaultValue(usersData, isMulti);
  return /*#__PURE__*/React.createElement(UserPicker, {
    accountId: accountId,
    cloudId: cloudId,
    productAttributes: productAttributes,
    productKey: productKey,
    mentionProvider: mentionProvider,
    name: name,
    label: label,
    placeholder: placeholder,
    description: description,
    defaultValue: hydratedDefaultValue,
    isRequired: isRequired,
    isMulti: isMulti,
    includeUsers: includeUsers,
    includeGroups: includeGroups,
    baseUrl: baseUrl,
    onChange: onChange,
    query: query
  });
};
export var makeMockUserPicker = function makeMockUserPicker(_ref3) {
  var query = _ref3.query,
    accountId = _ref3.accountId,
    cloudId = _ref3.cloudId,
    productKey = _ref3.productKey,
    baseUrl = _ref3.baseUrl;
  return function UserPickerNext(_ref4) {
    var props = _ref4.forgeDoc.props;
    var _ref5 = props,
      name = _ref5.name,
      label = _ref5.label,
      placeholder = _ref5.placeholder,
      description = _ref5.description,
      isRequired = _ref5.isRequired,
      isMulti = _ref5.isMulti,
      includeUsers = _ref5.includeUsers,
      includeGroups = _ref5.includeGroups,
      onChange = _ref5.onChange,
      defaultUserId = _ref5.defaultValue;
    var _useState = useState(!defaultUserId),
      _useState2 = _slicedToArray(_useState, 2),
      defaultValueLoaded = _useState2[0],
      setDefaultValueLoaded = _useState2[1];
    var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      defaultValue = _useState4[0],
      setDefaultValue = _useState4[1];
    useEffect(function () {
      if (defaultUserId && !defaultValueLoaded) {
        query().then(function (users) {
          var targetUsers = users.filter(function (_ref6) {
            var id = _ref6.id;
            return Array.isArray(defaultUserId) ? defaultUserId.includes(id) : defaultUserId === id;
          });
          if (targetUsers.length === 0) {
            setDefaultValue(undefined);
          } else {
            if (isMulti) {
              setDefaultValue(targetUsers);
            } else {
              setDefaultValue(targetUsers[0]);
            }
          }
          setDefaultValueLoaded(true);
        });
      }
    }, [isMulti, defaultUserId, defaultValueLoaded, setDefaultValue, setDefaultValueLoaded]);
    if (!defaultValueLoaded) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, null);
    }
    return /*#__PURE__*/React.createElement(UserPicker, {
      accountId: accountId,
      cloudId: cloudId,
      productKey: productKey,
      baseUrl: baseUrl,
      name: name,
      label: label,
      placeholder: placeholder,
      description: description,
      isRequired: isRequired,
      isMulti: isMulti,
      includeUsers: includeUsers,
      includeGroups: includeGroups,
      onChange: onChange,
      query: query,
      defaultValue: defaultValue
    });
  };
};

// ApolloClient, cloudId and productKey must be passed as props,
// and will not be fetched via context.
export var makeNativeUserPicker = function makeNativeUserPicker(_ref7) {
  var client = _ref7.client,
    mentionProvider = _ref7.mentionProvider,
    accountId = _ref7.accountId,
    cloudId = _ref7.cloudId,
    productKey = _ref7.productKey,
    baseUrl = _ref7.baseUrl,
    productAttributes = _ref7.productAttributes;
  return function UserPickerNext(_ref8) {
    var props = _ref8.forgeDoc.props;
    return /*#__PURE__*/React.createElement(UserPickerFn, {
      props: props,
      client: client,
      mentionProvider: mentionProvider,
      accountId: accountId,
      cloudId: cloudId,
      productAttributes: productAttributes,
      productKey: productKey,
      baseUrl: baseUrl
    });
  };
};
export { isProductKey } from './types';